import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TestStep } from '../../dto/test-step';
import { TestStepService } from '../../service/test-step.service';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dpi-test-step-list',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, NgIf, MatButtonToggleModule, MatTooltipModule],
  templateUrl: './test-step-list.component.html',
  styleUrl: './test-step-list.component.scss'
})
export class TestStepListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['sn', 'method', 'expected_result', 'result'];
  dataSource: TestStep[] = [];
  destroyed$ = new Subject<void>(); // notifier of component being destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  constructor(private testStepService: TestStepService, private notifyService: StateNotifyService, private router: Router) {
    this.isReadonly = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.testSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.reloadAll(model.id)
      });

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.isReadonly = res;
      });
  }

  reloadAll(testId: number) {
    this.testStepService.getAllTestStepsOfTest(testId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: res => {
          this.dataSource = res;
          this.notifyService.updateListAllTestStep(this.dataSource);
          this.listSize.emit(this.dataSource.length);
        },
        error: err => { console.log(err); this.dataSource = []; }
      });
  }

  selectTestStep(selected: TestStep) {
    this.notifyService.updateTestStepSelection(selected);
    this.router.navigate(['test-step-hub']);
  }

  createTestStep() {
    let testModel = this.notifyService.getSelectedTest();
    this.testStepService.createTestStep(testModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          //this.reloadAll(testModel.id);
          this.dataSource.push(model);
          this.selectTestStep(model);
        },
        error: err => { console.log(err); }
      });
  }

}
